import { required, min_value, max_value, email, integer, min } from 'vee-validate/dist/rules';

export default {
  required,
  min_value,
  max_value,
  email,
  integer,
  min,
};
